export const formatTime = (timestamp: number) => {
  const timestampSeconds = Math.trunc(timestamp);
  const hours = Math.floor(timestampSeconds / 3600);
  const minutes = Math.floor(timestampSeconds / 60) % 60;
  const seconds = timestampSeconds % 60;
  const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
  const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondesStr = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${hoursStr}:${minutesStr}:${secondesStr}`;
};
